<template>
  <div class="modal">
    <div class="modal-body modal-vwide" v-on-clickaway:mousedown="closeModal">
      <div class="modal-content flex-col" v-if="itemInited">
        <div class="gwd-table">
          <div class="gwd-table-header combined-costs-rows">
            <span>Programmikood</span>
            <span>Kirjeldus</span>
            <span>Kogus</span>
            <span />
            <span>Kulu</span>
            <span>Koefitsent</span>
            <span>Tulu</span>
            <span>Kulu*kogus</span>
            <span>Käibemaks</span>
            <span>Kulu/Tulu summa</span>
            <span />
          </div>
          <div
            v-for="cost in combinedCosts"
            :key="cost.id"
            class="gwd-table-row combined-costs-rows"
          >
            <div
              v-html="parseCostColorAndName(cost.type)"
              class="flex flex-row h-full"
              style="min-width: 7px"
            />
            <span class="flex justify-between items-center">
              <span>{{ cost.description }}</span>
              <button
                @click="toggleNameSelected(cost)"
                v-if="!nameUsed"
                class="pr-2"
              >
                <span class="label typcn typcn-arrow-down"></span>
              </button>
            </span>
            <span>{{ cost.amount }} {{ cost.unit }}</span>
            <span />
            <span>{{ cost.cost }} €</span>
            <span>{{
              cost.cost_coefficient ? cost.cost_coefficient : "-"
            }}</span>
            <span>{{ cost.price }} €</span>
            <span>{{ round2(cost.amount * cost.cost) }} €</span>
            <span>{{ cost.vatType ? cost.vatType.description : "-" }}</span>
            <div class="flex items-center">
              <span class="w-1/2"> {{ costWithCoef(cost) }} €</span>
              <span class="w-1/2"> {{ priceWithVat(cost) }} €</span>
            </div>
            <div class="flex justify-end">
              <button class="icon-button danger" @click="removeCost(cost)">
                <span class="typcn typcn-trash text-white" />
              </button>
            </div>
          </div>

          <div class="gwd-table-row combined-costs-rows">
            <div>
              <select
                v-model="item.serviceObj"
                class="w-full"
                :class="
                  showInvalid && !item.serviceObj
                    ? 'ring-danger ring-opacity-50 ring-2'
                    : ''
                "
                @change="
                  setDefaultServiceObjectFields(
                    item,
                    serviceObjects,
                    taxTypes,
                    defaultTaxType
                  )
                "
              >
                <option
                  v-for="serviceObj in serviceObjects"
                  :key="serviceObj.id"
                  :value="serviceObj"
                  :disabled="serviceObj.service_code.length === 2"
                >
                  {{
                    `${serviceObj.service_code} - ${serviceObj.service_name}`
                  }}
                </option>
              </select>
            </div>
            <div class="no-hover">
              <input type="text" v-model="item.description" class="w-full" />
            </div>
            <div class="no-hover">
              <decimal-input
                v-model="item.amount"
                class="w-full"
                :decimal-points="4"
                :class="
                  showInvalid && !item.amount
                    ? 'ring-danger ring-opacity-50 ring-2'
                    : ''
                "
              />
            </div>
            <div class="no-hover">
              <select class="add-offer-input" v-model="item.unit">
                <option v-for="unit in units" :value="unit" :key="unit">
                  {{ unit }}
                </option>
              </select>
            </div>
            <div></div>
            <div></div>
            <div class="no-hover">
              <decimal-input
                v-model="item.price"
                :decimal-points="4"
                class="w-full"
                :class="
                  showInvalid && !item.price
                    ? 'ring-danger ring-opacity-50 ring-2'
                    : ''
                "
              />
            </div>
            <div class="no-hover">
              <span> {{ round2(item.amount * item.price) }} €</span>
            </div>
            <div class="no-hover">
              <gwd-tax-selector v-model="item.taxType" :allow-outgoing="true" />
            </div>
            <div class="flex items-center">
              <span class="w-1/2" />
              <span class="w-1/2">
                {{ priceWithTaxType }}
                {{ currency ? currency.sign : "€" }}
              </span>
            </div>
          </div>
          <div class="gwd-table-row combined-costs-rows">
            <div class="flex items-center col-span-2">
              <button class="btn-primary" @click="addDate">
                Kuupäev
                <span class="label ml-1">
                  ({{
                    task
                      ? moment(task.start_time).format("DD.MM.YYYY")
                      : moment(ee).format("DD.MM.YYYY")
                  }})
                </span>
              </button>
              <button
                v-if="task"
                :class="task.address ? 'btn-primary' : 'btn-disabled'"
                @click="addStartAddress"
              >
                Algaadr.
              </button>
              <button
                v-if="task"
                :class="task.end_address ? 'btn-primary' : 'btn-disabled'"
                @click="addEndAddress"
              >
                Lõppaadr.
              </button>
              <button
                v-if="task"
                :class="
                  task.address && task.end_address
                    ? 'btn-primary'
                    : 'btn-disabled'
                "
                @click="addBothAddress"
              >
                Alg - Lõpp
              </button>
              <button v-if="task" class="btn-primary" @click="addTitle">
                Pealkiri
              </button>
            </div>
            <div
              v-if="!amountTotalUsed && item.amount === 0"
              class="flex items-center text-sm gap-x-2 col-span-2"
            >
              <button class="btn-primary" @click="sumAmount">
                <span class="label">sum</span>
              </button>
              <button class="btn-primary" @click="averageAmount">
                <span class="label">kesk.</span>
              </button>
              <button class="btn-primary" @click="maxAmount">
                <span class="label">max</span>
              </button>
            </div>
            <div v-else class="col-span-2" />
            <div />
            <div />
            <div
              v-if="!priceTotalUsed && item.price === 0"
              class="flex items-center text-sm gap-x-3 col-span-2"
            >
              <button class="btn-primary" @click="sumPrice">
                <span class="label">sum</span>
              </button>
              <button class="btn-primary" @click="averagePrice">
                <span class="label">kesk.</span>
              </button>
              <button class="btn-primary" @click="maxPrice">
                <span class="label">max</span>
              </button>
            </div>
            <div v-else class="col-span-2" />
            <div />
            <div
              class="flex items-center text-sm ml-1 col-span-2"
              v-if="!priceTotalUsed && !amountTotalUsed"
            >
              <button class="btn-primary" @click="calculateSumOfEach">
                <span class="label"> Summa </span>
              </button>
              <span class="text-sm mx-1">
                ({{ totalSum }} €/
                {{
                  round2(
                    totalSum +
                      (totalSum *
                        (item.taxType ? item.taxType.tax_percentage : 1)) /
                        100
                  )
                }}
                €)</span
              >
            </div>
            <div v-else class="col-span-2" />
          </div>
          <div class="gwd-table-row combined-costs-rows">
            <div
              class="flex items-center gap-x-3 col-span-11 justify-end h-full"
            >
              <div
                class="flex h-full items-center cursor-pointer"
                v-for="(typeObj, index) in totalHoursAndCosts"
                :key="index"
                @click="
                  setAmountAndCostFromTypeTotal(typeObj.amount, typeObj.sum)
                "
              >
                <div
                  class="flex h-full mr-0.5"
                  :style="parseCostColor(typeObj.type)"
                  style="min-width: 4px"
                />
                <span>
                  {{ typeObj.description }} ({{ typeObj.amount }}
                  {{ typeObj.unit }} / {{ typeObj.sum }} €)
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="gwd-table"
          v-if="revenueListsCopy.length > 1 && splitPayments"
          :key="componentKey"
        >
          <div
            v-for="(sepItem, index) in revenueListsCopy"
            :key="index"
            class="flex flex-col w-full gwd-table-row-wrapper"
          >
            <div class="flex mb-1">
              <h3>
                {{ sepItem.payer ? sepItem.payer.name : sepItem.client.name }}
              </h3>
            </div>
            <div class="gwd-table-row combined-costs-rows">
              <decimal-input
                v-model="sepItem.itemObj.percentage"
                class="pr-2"
                style="width: 80%"
              />
              <span>{{ item.description }}</span>
              <span>
                {{ round2((sepItem.itemObj.percentage * item.amount) / 100) }}
              </span>
              <span>{{ item.unit }}</span>
              <div></div>
              <div></div>
              <span> {{ item.price }} €</span>
              <span>
                {{
                  round2(
                    ((sepItem.itemObj.percentage * item.amount) / 100) *
                      item.price
                  )
                }}
                €</span
              >
              <span>{{
                item.taxType
                  ? `${
                      item.taxType.tax_percentage
                        ? item.taxType.tax_percentage
                        : "0"
                    }%`
                  : "-"
              }}</span>
              <span>
                {{
                  item.taxType
                    ? round2(
                        ((sepItem.itemObj.percentage * item.amount) / 100) *
                          item.price +
                          (((sepItem.itemObj.percentage * item.amount) / 100) *
                            item.price *
                            item.taxType.tax_percentage) /
                            100
                      )
                    : round2(
                        ((sepItem.itemObj.percentage * item.amount) / 100) *
                          item.price
                      )
                }}
                €
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-bottom-bar flex">
        <div class="flex" v-if="!splitPayments && revenueListsCopy.length > 1">
          <button class="btn-primary" @click="splitPayments = true">
            <span class="label">Jaga kulud</span>
          </button>
        </div>
        <div v-if="splitPayments && revenueListsCopy.length > 1" class="flex">
          <button class="btn-primary" @click="splitEven" v-if="!splitUsed">
            <span class="label">Jaga võrdselt</span>
          </button>
        </div>
        <button
          class="mr-3 ml-auto"
          :class="
            !splitPayments
              ? 'btn-primary'
              : percentageHundredCheck
              ? 'btn-primary'
              : 'btn-disabled'
          "
          :key="`second${componentKey}`"
          @click="saveRevenue"
        >
          Salvesta
        </button>
        <button class="btn-danger" @click="closeModal">Sulge</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import { Revenue } from "@/assets/types/Revenue";
import { mapGetters } from "vuex";
import {
  costWithCoef,
  priceWithVat,
  round2,
  round4,
} from "@/assets/utils/commonMath";
import DecimalInput from "../reusable/DecimalInput.vue";
import { setDefaultServiceObjectFields } from "@/assets/utils/commonInvoiceMethods";
import { ee } from "vuejs-datepicker/dist/locale";
import set from "lodash/set";
import CostTypeParser from "@/assets/mixins/CostTypeParser";
export default {
  name: "CombinedCostModal",
  props: {
    combinedCosts: {
      type: Array,
      default: () => {
        return [];
      },
    },
    revenueLists: {
      type: Array,
      default: null,
    },
    client: {
      type: Object,
      default: null,
    },
    payer: {
      type: Object,
      default: null,
    },
    task: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      item: null,
      itemInited: false,
      showInvalid: false,
      currency: null,
      moment: moment,
      priceTotalUsed: false,
      amountTotalUsed: false,
      splitUsed: false,
      nameUsed: false,
      splitPayments: false,
      revenueListsCopy: [],
      componentKey: 0,
      percentageHundredCheck: false,
      ee: ee,
    };
  },
  components: { DecimalInput },
  mixins: [CostTypeParser],
  methods: {
    priceWithVat,
    costWithCoef,
    round2,
    setDefaultServiceObjectFields,
    closeModal() {
      this.$emit("closeModal");
    },
    setAmountAndCostFromTypeTotal(amount, typeSum) {
      this.item.amount = amount;
      this.item.price = typeSum;
      this.priceTotalUsed = true;
      this.amountTotalUsed = true;
    },
    calculateSumOfEach() {
      this.item.amount = 1;
      this.item.price = round2(
        this.combinedCosts
          .map(
            (x) =>
              parseFloat(x.cost) *
              parseFloat(x.amount) *
              parseFloat(x.cost_coefficient)
          )
          .reduce((x, y) => x + y, 0)
      );
      this.priceTotalUsed = true;
      this.amountTotalUsed = true;
    },
    removeCost(cost) {
      this.item.removeCost(cost);
      this.$emit("removeCost", cost);
    },
    addDate() {
      if (this.task) {
        this.item.description = `${this.item.description}, ${moment(
          this.task.start_time
        ).format("DD.MM.YYYY")}`;
      } else {
        this.item.description = `${this.item.description}, (${moment(ee).format(
          "DD.MM.YYYY"
        )})`;
      }
    },
    addStartAddress() {
      if (!this.task.address) return;
      const start = this.task.address.split(",");
      let addr;
      if (start.length === 1) {
        addr = start[0];
      } else if (start.length > 2) {
        addr = start[0];
      } else {
        addr = `${start[0]}, ${start[1]}`;
      }
      this.item.description = `${this.item.description}, ${addr}`;
    },
    addEndAddress() {
      if (!this.task.end_address) return;
      const end = this.task.end_address.split(",");
      let endAddr;
      if (end.length === 1) {
        endAddr = end[0];
      } else if (end.length > 2) {
        endAddr = end[0];
      } else {
        endAddr = `${end[0]}, ${end[1]}`;
      }
      this.item.description = `${this.item.description}, ${endAddr}`;
    },
    addBothAddress() {
      if (!this.task.address) return;
      if (!this.task.end_address) return;
      const start = this.task.address.split(",");
      let addr;
      if (start.length === 1) {
        addr = start[0];
      } else if (start.length > 2) {
        addr = start[0];
      } else {
        addr = `${start[0]}, ${start[1]}`;
      }
      const end = this.task.end_address.split(",");
      let endAddr;
      if (end.length === 1) {
        endAddr = end[0];
      } else if (end.length > 2) {
        endAddr = end[0];
      } else {
        endAddr = `${end[0]}, ${end[1]}`;
      }
      this.item.description = `${this.item.description}, ${addr} - ${endAddr}`;
    },
    addTitle() {
      if (!this.task.title) return;
      this.item.description = `${this.item.description}, ${this.task.title}`;
    },
    formatItem(e) {
      e.amount = round2((this.item.amount * e.percentage) / 100);
      e.price = this.item.price;
      e.taxType = this.item.taxType;
      e.type = this.item.type;
      e.serviceObj = this.item.serviceObj;
      if (!e.description) e.description = this.item.description;
      return e;
    },
    saveRevenue() {
      if (this.revenueListsCopy.length > 0 && this.splitPayments) {
        this.revenueListsCopy.map((x) => {
          set(x, "itemObj", this.formatItem(x.itemObj));
        });
        this.$emit("splitRevenue", this.revenueListsCopy);
      } else {
        if (!this.item.description)
          this.item.description = this.item.service_name;
        this.$emit("revenueSaved", this.item);
      }
      this.closeModal();
    },
    splitEven() {
      const evenPercentage = round2(100 / this.revenueListsCopy.length);
      this.revenueListsCopy.forEach((x) =>
        this.$set(x.itemObj, "percentage", evenPercentage)
      );
      this.componentKey++;
    },
    toggleNameSelected(e) {
      this.item.service_name = e.description;
      this.nameUsed = true;
    },
    sumPrice() {
      if (!this.combinedCosts) return 0;
      this.priceTotalUsed = true;

      this.item.price = round4(
        this.combinedCosts.reduce(
          (prev, curr) =>
            parseFloat(prev) + parseFloat(curr.price ? curr.price : 0),
          0
        )
      );
    },
    averagePrice() {
      if (!this.combinedCosts) return 0;
      this.item.price = round4(
        this.combinedCosts
          .map((x) => parseFloat(x.price))
          .reduce((x, y) => x + y, 0) / this.combinedCosts.length
      );
      this.priceTotalUsed = true;
    },
    maxPrice() {
      if (!this.combinedCosts) return 0;
      this.item.price = round4(
        Math.max(...this.combinedCosts.map((x) => x.price))
      );
      this.priceTotalUsed = true;
    },
    averageAmount() {
      if (!this.combinedCosts) return 0;
      this.item.amount = round4(
        this.combinedCosts
          .map((x) => parseFloat(x.amount))
          .reduce((x, y) => x + y, 0) / this.combinedCosts.length
      );
      this.amountTotalUsed = true;
    },
    sumAmount() {
      if (!this.combinedCosts) return 0;
      this.item.amount = round4(
        this.combinedCosts.reduce(
          (prev, curr) =>
            parseFloat(prev) + parseFloat(curr.amount ? curr.amount : 0),
          0
        )
      );
      this.amountTotalUsed = true;
    },
    maxAmount() {
      if (!this.combinedCosts) return 0;
      this.item.amount = round4(
        Math.max(...this.combinedCosts.map((x) => x.amount))
      );
      this.amountTotalUsed = true;
    },
  },
  async mounted() {
    document.body.classList.add("modal-open");
    if (!this.taxTypes)
      await this.$store.dispatch("companyVariables/retrieveTaxTypes");
    if (!this.serviceObjects)
      await this.$store.dispatch("companyVariables/retrieveServiceObjects");
    this.revenueListsCopy = JSON.parse(JSON.stringify(this.revenueLists));
    this.item = new Revenue(
      null,
      this.defaultServiceCode,
      0,
      null,
      this.defaultTaxType,
      0,
      this.combinedCosts.map((x) => `${x.type}${x.id}`),
      null
    );
    this.setDefaultServiceObjectFields(
      this.item,
      this.serviceObjects,
      this.taxTypes,
      this.defaultTaxType
    );
    if (this.revenueListsCopy.length > 1) {
      this.revenueListsCopy.forEach((x) => {
        this.$set(
          x,
          "itemObj",
          new Revenue(
            null,
            null,
            0,
            this.item.unit,
            this.item.taxType,
            0,
            this.combinedCosts.map((x) => `${x.type}${x.id}`),
            "",
            0
          )
        );
      });
    }

    this.itemInited = true;
  },
  beforeDestroy() {
    document.body.classList.remove("modal-open");
  },
  watch: {
    revenueListsCopy: {
      deep: true,
      handler() {
        this.percentageHundredCheck =
          round2(
            this.revenueListsCopy.reduce(
              (prev, curr) =>
                parseFloat(prev) + curr.itemObj ? curr.itemObj.percentage : 100,
              0
            )
          ) -
            100 <
          Number.EPSILON;
      },
    },
  },
  computed: {
    ...mapGetters({
      taxTypes: "companyVariables/taxTypes",
      companyId: "companyData/activeCompanyUuid",
      currencyList: "companyVariables/currencyList",
      serviceObjects: "companyVariables/serviceObjects",
      units: "companyVariables/units",
    }),
    defaultTaxType() {
      if (!this.taxTypes) return null;
      if (this.payer) {
        if (this.payer.default_vat_code)
          return this.taxTypes.find(
            (x) => x.id === this.payer.default_vat_code
          );
        return this.taxTypes
          .filter((x) => x.outgoing_tax_code)
          .find((x) => x.default);
      }
      if (this.client) {
        if (this.client.default_vat_code)
          return this.taxTypes.find(
            (x) => x.id === this.client.default_vat_code
          );
        return this.taxTypes
          .filter((x) => x.outgoing_tax_code)
          .find((x) => x.default);
      } else {
        return this.taxTypes
          .filter((x) => x.outgoing_tax_code)
          .find((x) => x.default);
      }
    },
    defaultServiceCode() {
      if (!this.serviceObjects) return null;
      const defaultService =
        this.$store.state.companyData.activeCompany.default_service_code;
      if (defaultService)
        return this.serviceObjects.find((x) => x.id === defaultService);
      return null;
    },
    priceWithTaxType() {
      let vatPercentage = this.item.taxType
        ? this.item.taxType.tax_percentage
        : "0";
      if (!vatPercentage) {
        return round2(this.item.price * this.item.amount);
      }
      return round2(
        this.item.price * this.item.amount +
          (this.item.price * this.item.amount * parseFloat(vatPercentage)) / 100
      );
    },
    totalHoursAndCosts() {
      let finalCosts = [];
      for (const typeObj of [
        {
          type: "workerCost",
          estDescription: "Töötunnid",
        },
        {
          type: "extraCost",
          estDescription: "Lisatööd",
        },
        {
          type: "resourceCost",
          estDescription: "Ressurssi kulud",
        },
        {
          type: "equipmentCost",
          estDescription: "Tehnika kulud",
        },
        {
          type: "supplierCost",
          estDescription: "Hankija kulud",
        },
      ]) {
        let costs = this.combinedCosts.filter((x) => x.type === typeObj.type);

        if (costs.length === 0) continue;
        finalCosts.push({
          type: typeObj.type,
          description: typeObj.estDescription,
          amount: round2(
            costs.reduce((prev, curr) => prev + parseFloat(curr.amount), 0)
          ),
          sum: round2(
            costs.reduce(
              (prev, curr) =>
                prev +
                parseFloat(
                  curr.cost * curr.amount * curr.cost_coefficient ?? 1
                ),
              0
            )
          ),
          unit: costs[0].unit,
        });
      }
      return finalCosts;
    },
    totalSum() {
      return round2(
        round2(
          this.combinedCosts
            .map(
              (x) =>
                parseFloat(x.cost) *
                parseFloat(x.amount) *
                parseFloat(x.cost_coefficient)
            )
            .reduce((x, y) => x + y, 0)
        )
      );
    },
  },
};
</script>
<style scoped lang="scss">
.combined-costs-rows {
  @apply items-center gap-x-2;
  grid-template-columns: 0.3fr 0.9fr 0.4fr 0.25fr 0.25fr 0.25fr 0.25fr 0.4fr 0.5fr 0.5fr 0.1fr;
}
</style>
